import { Link } from "react-router-dom";
import { heroData, hotComics } from "@/mocks/homeData";
import { useState } from "react";

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const featuredComics = hotComics.slice(0, 3);

  const goToSlide = (index: number) => {
    setCurrentSlide((index + featuredComics.length) % featuredComics.length);
  };

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[720px] flex items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20with%20dynamic%20action%20scene%20featuring%20comic%20panels%20and%20speed%20lines%2C%20vibrant%20warm%20red%20and%20orange%20tones%2C%20dramatic%20composition%20with%20manga%20character%20silhouettes%2C%20stylized%20comic%20book%20aesthetic%20with%20halftone%20dots%20pattern%2C%20clean%20gradient%20background%20transitioning%20from%20dark%20charcoal%20to%20warm%20deep%20red%2C%20high%20contrast%20artistic%20render%2C%202D%20anime%20art%20style%20with%20bold%20outlines%20and%20cel%20shading&width=1920&height=1080&seq=hero-main-bg&orientation=landscape"
          alt="51漫画 - 精彩漫画世界"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-foreground-950/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 mb-6 whitespace-nowrap">
              {heroData.tag}
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-7xl font-black text-background-50 leading-tight text-balance">
              {heroData.title}
            </h1>
            <p className="font-heading text-xl md:text-2xl lg:text-3xl text-accent-400 font-semibold mt-3 text-balance">
              {heroData.subtitle}
            </p>
            <p className="mt-5 text-sm md:text-base text-foreground-300 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              {heroData.description}
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <Link
                to={heroData.primaryLink}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap w-full sm:w-auto justify-center"
              >
                <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
                {heroData.primaryButton}
              </Link>
              <Link
                to={heroData.secondaryLink}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap w-full sm:w-auto justify-center"
              >
                <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center"></i>
                {heroData.secondaryButton}
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={featuredComics[currentSlide].cover}
                  alt={featuredComics[currentSlide].title}
                  className="w-full aspect-[3/4] md:aspect-[4/5] object-cover object-top transition-all duration-500"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 md:p-6 rounded-b-2xl">
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
                  {featuredComics[currentSlide].title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-300 mt-1">
                  {featuredComics[currentSlide].author} · {featuredComics[currentSlide].views} 阅读
                </p>
                <div className="flex items-center gap-1 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill w-3 h-3 flex items-center justify-center ${
                        i < Math.round(featuredComics[currentSlide].rating / 2)
                          ? "text-accent-400"
                          : "text-foreground-600"
                      }`}
                    ></i>
                  ))}
                  <span className="text-xs text-accent-400 ml-1">{featuredComics[currentSlide].rating}</span>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 mt-4">
              {featuredComics.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    index === currentSlide
                      ? "bg-accent-500 w-8"
                      : "bg-background-50/30 hover:bg-background-50/50"
                  }`}
                  aria-label={`切换到第${index + 1}张`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}